import { ENDPOINTS } from '../constants';

class IsolatedClient {
  #type;

  type(value) {
    this.#type = value;

    return this;
  }

  get() {
    return this._execute();
  }

  post() {
    return this._execute();
  }

  patch() {
    return this._execute();
  }

  put() {
    return this._execute();
  }

  async _execute() {
    switch (this.#type) {
      case ENDPOINTS.candidates:
        return { data: { present: false } };
      case ENDPOINTS.partial_candidates:
        return import('./partial_candidates.json');
      case ENDPOINTS.settings_data:
        return import('./options_lists.json');
      default:
        return {};
    }
  }
}

export default IsolatedClient;
